import React from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import { QuestionFrom } from './components';
import { Home, Prepare, PageNotFound, Quiz, Ranking, Login, Admin } from './pages';
import './App.css'

const App = () => {
    return (
        <div className='main-container'>
            <div className='app'>
                <Routes>
                    <Route exact path='/' element={<Home />}/>
                    <Route exact path='/prepare' element={<Prepare />}/>
                    <Route exact path='/play' element={<Quiz />}/>
                    <Route exact path='/ranking' element={<Ranking />}/>
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </div>
        </div>
    )
}

export default App
